/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Household_Teen_Confirm_TitleInputs */

const fr_household_teen_confirm_title = /** @type {(inputs: Household_Teen_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Désinscrire aussi ${i?.names} ?`)
};

/**

* @param {Household_Teen_Confirm_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_teen_confirm_title = /** @type {((inputs: Household_Teen_Confirm_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Teen_Confirm_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_teen_confirm_title(inputs)
});